import React from 'react';
import Fontawesome from '../../fontawesome/fontawesome';
import { Link } from 'react-router-dom';
import OptionEmployeeClients from '../../employers_clients/optionsEmployeeClients';

const OptionsClients = (props) => {
  return (
    <div className="dropdown">
      <Link
        to="#"
        className="dropdown link_color_datatable"
        id="dropdownNotification"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        <Fontawesome classe="fas fa-bars" />
      </Link>
      <ul
        className="dropdown-menu fade-in-top drop-options"
        aria-labelledby="dropdownNotification"
      >
        <li>
          <OptionEmployeeClients iconClass="fas fa-key mr-2" id={props.id} />
        </li>
      </ul>
    </div>
  );
};
export default OptionsClients;
